import { z } from 'zod'

export const ConfigurationAdminBreakersZod = z.object({
  automatedAssignments: z
    .object({
      disabled: z.boolean(),
      message: z.string().optional(),
    })
    .optional()
    .default({ disabled: false }),
  mobileAppRequests: z
    .object({
      disabled: z.boolean(),
      message: z.string().optional(),
    })
    .optional()
    .default({ disabled: false }),
})
